import { ADMIN_RESELLER_ROLE_ID } from "./useIsReseller";

const ADMIN_RESELLER_ROLE_NAME = "admin reseller";

const readStorage = (key: string): string => {
  try {
    return localStorage.getItem(key) || "";
  } catch {
    return "";
  }
};

export const canSeeDevicePairing = (): boolean =>
  readStorage("userRoleId") === ADMIN_RESELLER_ROLE_ID ||
  readStorage("userRole").trim().toLowerCase() === ADMIN_RESELLER_ROLE_NAME;

export const useCanSeeDevicePairing = canSeeDevicePairing;

export default useCanSeeDevicePairing;
